export class ConflictError extends Error {
  constructor(message?: string | undefined, public traceId?: string) {
    super(message);

    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, ConflictError.prototype);
  }
}
